import _ from 'lodash';
import React, { useEffect } from 'react';
import OrderStore from 'ui/run/RunShow/OrderStore/index';
import RunDetail from 'ui/run/RunShow/components/RunDetail/index';
import TransactionDetail from 'ui/run/RunShow/components/TransactionDetail/index';
import { RUN_TYPES } from 'common/constants/index';
import { strategyPropTypes, userPropTypes } from 'common/propTypes';
import PropTypes from 'prop-types';
import subscribeChannel from 'common/api/subscribeChannel';
import RunTitleAndActions from 'ui/run/RunShow/components/RunTitleAndActions/index';
import LiveMonitor from 'ui/run/RunShow/components/LiveMonitor/index';
import ArrowAccordion from 'common/components/ArrowAccordion';

const propTypes = {
  strategy: strategyPropTypes.isRequired,
  isAccordianOpen: PropTypes.bool,
  currentUser: userPropTypes
};
const defaultProps = {
  isAccordianOpen: false,
  currentUser: null
};

const StrategyLiveRunDetails = ({ strategy, isAccordianOpen, currentUser }) => {
  const { liveJobs, liveRun, is_manual_signals_allowed: isAllowManualSignals } = strategy;
  const liveJobIds = _.map(liveJobs, 'id').sort();
  const liveRunId = _.get(liveJobs, '[0].run_id');
  const { order_type: orderType } = liveRun;
  const jobId = _.head(liveJobIds);

  const currentUserId = _.get(currentUser, 'id', null);
  const strategyUserId = _.get(strategy, 'user_id', null);
  const isOwnRun = currentUserId === strategyUserId;

  useEffect(() => {
    const socketConnection = {
      channelName: 'NotificationsChannel',
      roomId: `job_${jobId}`,
      onDataReceive: () => {
        setTimeout(() => { window.location.reload(); }, 1000);
      }
    };

    subscribeChannel(socketConnection);
  }, []);

  const renderLiveMonitor = () => (
    isOwnRun && liveRun && liveJobs && liveJobs.length > 0 && (
        <OrderStore
          runIds={[_.get(liveRun, 'id')]}
          jobIds={_.map(liveJobs, 'id')}
          runType={RUN_TYPES.live}
          run={liveRun}
        >
          <LiveMonitor
            run={liveRun}
            jobIds={_.map(liveJobs, 'id')}
            instrumentGroups={_.get(liveRun, 'quant_config.instrumentGroups', [])}
            pipeConfigs={_.get(liveRun, 'quant_config.pipeConfigs', [])}
            onOrderReceived={() => {}}
            isOwnRun={isOwnRun}
          />
        </OrderStore>
    )
  );

  return (
    <div className="strategy-order-store mt-3">
      <OrderStore
        runIds={[liveRunId]}
        jobIds={[liveJobIds]}
        runType={RUN_TYPES.live}
        orderType={orderType}
        run={liveRun}
      >
        <div className="marketplace-live">
          {!isAllowManualSignals && (
            <RunTitleAndActions
              run={liveRun}
              currentUser={currentUser}
              strategyDetails={{}}
            />
          )}
          <RunDetail run={liveRun} />
          <ArrowAccordion title="Live Monitor" defaultOpen>
            {renderLiveMonitor()}
          </ArrowAccordion>
          <TransactionDetail run={liveRun} isAccordianOpen={isAccordianOpen} />
        </div>
      </OrderStore>
    </div>
  );
};

StrategyLiveRunDetails.propTypes = propTypes;
StrategyLiveRunDetails.defaultProps = defaultProps;

export default StrategyLiveRunDetails;
